<template>
    <section class="section">
        <div class="hero">
            <div class="hero-head has-text-centered">
                <h1 class="title is-1">Deployment Statistics</h1>
            </div>
        </div>
        <br>
        <div class="container">
            <div class="tile is-ancestor" style="flex-wrap: wrap; justify-content: center;">
                <div v-for="(deployment, index)  in deployments" :v-key="deployment.name + index"
                     class="tile is-parent" style="justify-content: center;">
                    <router-link class="tile is-child card" style="max-width: 25rem; min-width: 15rem; width: 20rem;" :to="{name: 'deployment_detail', params: {deploymentId: deployment.id}}">
                        <header class="card-header">
                            <h1 class="card-header-title title" style="margin: 0;">{{deployment.name}}</h1>
                        </header>
                        <div class="card-content">
                            <h4 class="title is-4 is-marginless">Totals:</h4>
                            <amount-table :amounts="deployment.totals"></amount-table>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapState} from "vuex";
    import AmountTable from "./AmountTable";

    export default {
        name: "DeploymentOverview",
        components: {AmountTable},
        computed: {
            ...mapState('deployment', [
                'deployments',
            ]),
        },
    }
</script>

<style scoped>

</style>